import { render, staticRenderFns } from "./TextWidgetPanel.vue?vue&type=template&id=631cd878&scoped=true"
import script from "./TextWidgetPanel.vue?vue&type=script&lang=js"
export * from "./TextWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./TextWidgetPanel.vue?vue&type=style&index=0&id=631cd878&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631cd878",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('631cd878')) {
      api.createRecord('631cd878', component.options)
    } else {
      api.reload('631cd878', component.options)
    }
    module.hot.accept("./TextWidgetPanel.vue?vue&type=template&id=631cd878&scoped=true", function () {
      api.rerender('631cd878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/TextWidgetPanel.vue"
export default component.exports